import { Button, type ButtonProps } from '@mui/material';
import { forwardRef } from 'react';
import { SEMANTIC_COLOR_VARS, type SemanticColor } from './semanticColor';

interface SoftButtonProps extends Omit<ButtonProps, 'color'> {
  tone?: SemanticColor;
}

/**
 * Tinted "soft" button — soft background + translucent border at rest, solid
 * fill on hover. This is the dominant button style in the redesign
 * (Generate, Review, Chat with Agent, filter tabs). Implemented as a wrapper
 * around MUI's Button rather than a new theme `variant` to avoid the module-
 * augmentation ceremony for a single style.
 */
export const SoftButton = forwardRef<HTMLButtonElement, SoftButtonProps>(function SoftButton(
  { tone = 'primary', sx, ...rest },
  ref,
) {
  const vars = SEMANTIC_COLOR_VARS[tone];
  return (
    <Button
      ref={ref}
      sx={{
        color: vars.main,
        backgroundColor: vars.soft,
        border: '1px solid',
        borderColor: vars.line,
        '&:hover': {
          backgroundColor: vars.main,
          color: '#fff',
          borderColor: vars.main,
        },
        ...sx,
      }}
      {...rest}
    />
  );
});
